/**
 * Allowlist de share por email.
 * `as_editor: true` suma editor (no saca). En público solo valen entradas
 * con `as_editor` (observador → 400).
 *
 * @param {string[]} emails
 * @param {{ asEditorEmails?: string[] }} [options]
 * @returns {{ type: 'email', value: string, as_editor?: true }[]}
 */
export function buildEmailAllowlist(emails, { asEditorEmails } = {}) {
  const editors = new Set(
    (Array.isArray(asEditorEmails) ? asEditorEmails : [])
      .map((raw) => String(raw || '').trim().toLowerCase())
      .filter(Boolean),
  );
  const seen = new Set();
  const rows = [];
  (Array.isArray(emails) ? emails : []).forEach((raw) => {
    const value = String(raw || '').trim().toLowerCase();
    if (!value || seen.has(value)) return;
    seen.add(value);
    const row = { type: 'email', value };
    if (editors.has(value)) row.as_editor = true;
    rows.push(row);
  });
  return rows;
}
